import React, { useState } from "react";
import { Modal } from "antd";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";

const DeleteColumnModal = ({
  preview,
  previewHandler,
  selectedColumn,
  successHandler,
}) => {
  const [deleteLoader, setdeleteLoader] = useState(false);
  const { http } = global.services;

  const deleteFileHandler = () => {
    setdeleteLoader(true);
    http
      .delete(`pipeline/${selectedColumn.id}`)
      .finally(() => setdeleteLoader(false))
      .then(() => {
        toast.success("Column deleted successfully");
        successHandler(selectedColumn.id);
        previewHandler();
      })
      .catch(() => {});
  };

  return (
    <Modal
      visible={preview}
      centered
      className="delete-column-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Delete Column</h2>
      <p>Are you sure you want to delete {selectedColumn?.name}?</p>
      <div className="action-box">
        <button onClick={previewHandler}>Cancel</button>
        <button className="delete" onClick={deleteFileHandler}>
          {deleteLoader ? <BeatLoader size={8} color="#fff" /> : "Delete"}
        </button>
      </div>
    </Modal>
  );
};

export default DeleteColumnModal;
